import { createSlice } from "@reduxjs/toolkit";

export const commonSlice = createSlice({
    name: "commonData",
    initialState: {
        offsetTag: 0,
        pageSizeTag: 10,
        searchText: "",
        fileType: "",
        tagNames: [],
        tagNameFlag : false,
        showMoreTag : false,
        loadingTag : false,
        orientation: "",
        tagList: [],
        totalCountTag: 0,
        searchType: null,
        locationName: "",
        eventName: "",
        selectMonthAndYear: null,
        selectYear: null,
        // true when tagList holds the fallback rows (files matching only SOME of
        // the words, shown because nothing matched every word)
        tagListIsFallback: false,
    },

    reducers: {
        setOffsetTag: (state, action) => {
            state.offsetTag = action.payload;
        },
        setPageSizeTag: (state, action) => {
            state.pageSizeTag = action.payload;
        },
        setSearchText: (state, action) => {
            state.searchText = action.payload;
        },
        setFileType: (state, action) => {
            state.fileType = action.payload;
        },
        setShowMoreTag: (state, action) => {
            state.showMoreTag = action.payload;
        },
        setLoadingTag: (state, action) => {
            state.loadingTag = action.payload;
        },
        setOrientation: (state, action) => {
            state.orientation = action.payload;
        },
        setTagList: (state, action) => {
            state.tagList = action.payload;
        },
        setTotalCountTag: (state, action) => {
            state.totalCountTag = action.payload;
        },
        setSearchType: (state, action) => {
            state.searchType = action.payload;
        },
        setLocationName: (state, action) => {
            state.locationName = action.payload;
        },
        setEventName: (state, action) => {
            state.eventName = action.payload;
        },

        setSelectMonthAndYear: (state, action) => {
            state.selectMonthAndYear = action.payload;
        },
        setSelectYear: (state, action) => {
            state.selectYear = action.payload;
        },
        setTagListIsFallback: (state, action) => {
            state.tagListIsFallback = Boolean(action.payload);
        },
        setTagNames: (state, action) => {
            state.tagNames = action.payload;
        },
        setTagNameFlag: (state, action) => {
            state.tagNameFlag = action.payload;
        },
        resetSearch: (state) => {
            state.searchText = "";
            state.locationName = "";
            state.eventName = "";
            state.orientation = "";
            state.selectMonthAndYear = null;
            state.selectYear = null;
        },
    },
});

export const { setOffsetTag, setPageSizeTag, setSearchText, setFileType, setShowMoreTag,
    setLoadingTag, setOrientation, setTagList, setTotalCountTag, setSearchType, setLocationName,setEventName, setSelectMonthAndYear,setSelectYear, setTagNames, setTagNameFlag, setTagListIsFallback, resetSearch } = commonSlice.actions;

export default commonSlice.reducer;